import { render, staticRenderFns } from "./InputId.vue?vue&type=template&id=0c2ace16"
import script from "./InputId.vue?vue&type=script&lang=js"
export * from "./InputId.vue?vue&type=script&lang=js"
import style0 from "./InputId.vue?vue&type=style&index=0&id=0c2ace16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports